import {
  map, catchError, mergeMap, takeUntil, debounceTime,
} from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { stringify } from 'query-string';
import { apiCall } from '../../../utils';

const INITIAL_STATE = {
  data: {},
  loading: false,
  error: false,
  flag: false,
};

const GET_FILTER_VALUES = 'GET_FILTER_VALUES';
const GET_FILTER_VALUES_CANCEL = 'GET_FILTER_VALUES_CANCEL';
const GET_FILTER_VALUES_SUCCESS = 'GET_FILTER_VALUES_SUCCESS';
const GET_FILTER_VALUES_FAILURE = 'GET_FILTER_VALUES_FAILURE';
const GET_FILTER_VALUES_RESET = 'GET_FILTER_VALUES_RESET'

// Auto Complete cancel action
export const getFilterValuesCancelAction = () => ({
  type: GET_FILTER_VALUES_CANCEL,
});

// Auto Complete action
export const getFilterValuesAction = (payload) => ({
  type: GET_FILTER_VALUES,
  payload,
});

// Auto Complete Success action
const getFilterValuesSuccess = (payload) => ({
  type: GET_FILTER_VALUES_SUCCESS,
  payload,
});

export const getFilterValuesEpic = (actions$) => actions$.pipe(
  ofType(GET_FILTER_VALUES),
  debounceTime(500),
  mergeMap((action) => ajax(
    apiCall(`${process.env.apiUrl}v0/queries/getFilters?${stringify(action.payload)}`, 'get'),
  ).pipe(
    map((res) => getFilterValuesSuccess(res)),
    takeUntil(actions$.pipe(ofType(GET_FILTER_VALUES_CANCEL))),
    catchError((err) => of({
      type: GET_FILTER_VALUES_FAILURE,
      payload: err,
    })),
  )),
);

export function getFilterValuesReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_FILTER_VALUES: {
      return {
        data: {},
        loading: true,
        flag: false,
        error: false,
      };
    }
    case GET_FILTER_VALUES_SUCCESS: {
      return {
        data: action.payload.response.data,
        loading: false,
        flag: true,
        error: false,
      };
    }
    case GET_FILTER_VALUES_RESET: {
      return {
        data: {},
        loading: false,
        flag: false,
        error: false,
      }
    }
    case GET_FILTER_VALUES_FAILURE: {
      return {
        data: {},
        loading: false,
        flag: false,
        error: true,
      };
    }
    default:
      return state;
  }
}
